// Dependencies
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
// Components
import Timeline from '../components/timeline';
import Gradient from '../components/gradient';
import ShareBar from '../components/share-bar';
import Credit from '../components/credit';
import SnowflakeOne from '../components/snowflake-one';
import SnowflakeTwo from '../components/snowflake-two';
import AudioToggle from '../components/audio-toggle';
// Actions
import toggleAudio from '../actions/audio';
// Constants
import { THEMES } from '../constants/config';

class Shell extends Component {
  handleAudioToggle() {
    this.props.dispatch(toggleAudio(!this.props.audio));
  }
  render() {
    const {
      children,
      currentStep,
      steps,
      audio,
      snowflakes,
      timeline,
      currentTheme
    } = this.props;
    return (
      <div className="shell">
        <Gradient themes={THEMES} currentTheme={currentTheme} />
        <div>
          {[...Array(3)].map((x, i) =>
            <SnowflakeOne
              className={classNames('snowflake snowflake--one', {
                'snowflake--exploded': snowflakes
              })}
              key={i + 1}
            />
          )}
          {[...Array(3)].map((x, i) =>
            <SnowflakeTwo
              className={classNames('snowflake snowflake--two', {
                'snowflake--exploded': snowflakes
              })}
              key={i + 1}
            />
          )}
        </div>
        {children}
        <Credit />
        <AudioToggle
          className={classNames('audio-toggle', {
            'audio-toggle--unmuted': audio
          })}
          onClick={this.handleAudioToggle.bind(this)}
        />
        <Timeline
          className={classNames({ 'timeline--hidden': !timeline })}
          steps={steps}
          currentStep={currentStep}
          totalSteps={steps.length}
        />
        <ShareBar />
      </div>
    );
  }
}

function mapStateToProps({
  currentStep,
  steps,
  audio,
  snowflakes,
  timeline,
  currentTheme
}) {
  return {
    currentStep,
    steps,
    audio,
    snowflakes,
    timeline,
    currentTheme
  };
}

export default connect(mapStateToProps)(Shell);



/** WEBPACK FOOTER **
 ** ./src/js/containers/shell.js
 **/